module.exports = require("././ui-bootstrap-tpls.js");


/*****************
 ** WEBPACK FOOTER
 ** angular-bootstrap (bower component)
 ** module id = 155
 ** module chunks = 0
 **/